import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import ScrollDownIndicator from "components/Home/ScrollDownIndicator";
import Lottie from "lottie-react";
import heroTech from "assets/lottie/12.json";
import { useNavigate } from "react-router-dom"; // <-- import navigation hook

export default function HeroSection() {
  const navigate = useNavigate(); // ✅ place this before return

  return (
    <MKBox position="relative" zIndex={1}>
      {/* Animated background blobs */}
      <MKBox
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        zIndex={0}
        sx={{
          overflow: "hidden",
          "& .blob": {
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(100px)",
            opacity: 0.6,
            animation: "float 10s ease-in-out infinite",
          },
        }}
      >
        <MKBox
          className="blob"
          sx={(theme) => ({
            top: "10%",
            left: "5%",
            width: "200px",
            height: "200px",
            background: theme.palette.gradients.dark.main,
          })}
        />
        <MKBox
          className="blob"
          sx={(theme) => ({
            bottom: "15%",
            right: "10%",
            width: "250px",
            height: "250px",
            background: theme.palette.gradients.secondary.main,
          })}
        />
      </MKBox>

      {/* Main hero content */}
      <MKBox
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems="center"
        justifyContent="space-between"
        px={3}
        pt={{ xs: 8, md: 20 }}
        pb={{ xs: 4, md: 1 }}
        zIndex={1}
        position="relative"
        sx={{ color: "white" }}
      >
        {/* Left Text Section */}
        <MKBox
          width={{ xs: "100%", md: "50%" }}
          textAlign={{ xs: "center", md: "left" }}
          sx={{
            zIndex: 1,
            ml: { xs: 0, md: 10 },
          }}
        >
          <MKTypography
            variant="h2"
            fontWeight="bold"
            gutterBottom
            sx={{
              mb: 2,
              opacity: 0,
              animation: "fadeSlideIn 0.8s ease-out forwards",
              animationDelay: "0.2s",
            }}
          >
            Smarter Tools. Better Business.
          </MKTypography>

          <MKTypography
            variant="body1"
            opacity={0.8}
            mb={2}
            sx={{
              opacity: 0,
              animation: "fadeIn 1s ease-out forwards",
              animationDelay: "0.6s",
            }}
          >
            Experience intelligent automation and a powerful way to scale your business.
          </MKTypography>

          <MKButton
            color="white"
            size="large"
            onClick={() => navigate("/contact")} // ✅ route on click
            sx={{
              mt: 1,
              opacity: 0,
              animation: "fadeIn 1s ease-out forwards",
              animationDelay: "1s",
              transition: "transform 0.3s ease, backgroundColor 0.3s ease",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                color: "#168980",
                transform: "scale(1.05)",
              },
            }}
          >
            Get Started
          </MKButton>
        </MKBox>

        {/* Lottie Animation on Right */}
        <MKBox
          width={{ xs: "100%", md: "45%" }}
          mt={{ xs: 4, md: 0 }}
          sx={{
            display: "flex",
            justifyContent: "center",
            pt: { xs: 2, md: 0 },
          }}
        >
          <Lottie animationData={heroTech} loop autoplay style={{ width: "100%", maxWidth: 600 }} />
        </MKBox>
      </MKBox>

      {/* Scroll Down Indicator */}
      <ScrollDownIndicator />
    </MKBox>
  );
}
